import React from 'react';
import styled from 'styled-components';
import MapImg from '../assets/images/mappp.png';
import PText from './PText';

const MapStyles = styled.div`
  background: url(${MapImg}) no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 400px;
  .container {
    position: relative;
    min-height: 400px;
  }
  .map__card {
    position: absolute;
    right: 10%;
    bottom: 10%;
    padding: 2rem;
    background: var(--deep-dark);
    width: 100%;
    max-width: 300px;
    border-radius: 12px;
  }
  .map__card__heading {
    font-size: 3rem;
    margin-bottom: 1rem;
  }
  .map__card__link {
    display: inline-block;
    font-size: 1.6rem;
    margin-top: 3rem;
    text-decoration: underline;
  }
  @media only screen and (max-width: 768px) {
    background-position: 80% center;
  }
  @media only screen and (max-width: 400px) {
    .map__card {
      max-width: none;
      right: auto;
    }
  }
`;

export default function Map() {
  return (
    <MapStyles>
      <div className="container">
        <div className="map__card">
          <h3 className="map__card__heading">Here is me</h3>
          <PText>West Deobhog, Narayanganj-1400, Dhaka, Bangladesh</PText>
          <a
            className="map__card__link"
            href="https://www.google.com/maps/place/23%C2%B036'54.0%22N+90%C2%B029'12.5%22E/@23.6144277,90.485221,17.86z/data=!4m9!1m2!2m1!1swest!3m5!1s0x3755b0549589bb09:0x46741d39aee7d039!7e2!8m2!3d23.6149934!4d90.4868048"
            target="_blank"
            rel="noreferrer"
          >
            Open in google map
          </a>
        </div>
      </div>
      {/* <img src={MapImg} alt="Map" /> */}
    </MapStyles>
  );
}
